<template>
  <div class="DataTables NewPartFormComponent ">

    <p><span v-if="isAll"><b-spinner small label="alert" type="grow" variant="danger"></b-spinner> {{lang.infotext_3}}</span></p>
    <p><span v-if="isCisCompatible == true"><b-spinner small label="alert" type="grow" variant="warning"></b-spinner> {{lang.infotext_4}}</span></p>
    <span v-if="!isAll">
    <p>{{lang.infotext_1}}: {{categoryName}}</p>
    <LoaderComponent  v-if="!isData"></LoaderComponent>
    <div :id="id"></div>
    <p><b-badge class="badge badge-blue">Request</b-badge> - {{lang.infotext_2}}</p>
    </span>
  </div>
</template>
<script>
  import PartPropertiesType from '@/constants/PartPropertiesType'
  import LoaderComponent from "@/components/shared/LoaderComponent"


  export default {
    name: "NewPartFormComponent",
    props:{
      lang: Object
    },
    components: {

      LoaderComponent
    },
    data () {
      return {

        mainTable: "",
        id: "NewPartFormComponent",
        properties: [],
        altSymbolsParams: {}

      }
    },
    computed: {
      isCisCompatible(){
        return this.$store.getters.selectedTreeItemObject.depth == 2 && this.$store.getters.selectedTreeItemObject.cisCompatible == true;
      },
      isAll(){
        if (this.$store.getters.selectedTreeItemObject.categoryId == 1){
          return true;
        }
        return false;
      },
      isData(){
        return this.properties.length != 0;
      },
      categoryId(){
        return this.$store.getters.selectedTreeItemObject.categoryId;
      },
      categoryName(){
        return this.$store.getters.selectedTreeItemObject.category;
      },
      variant(){
        if (this.$store.getters.s_skinVariant == "dark"){
          return "light";
        }else{
          return "dark";
        }
        
      }

    },
    created () {
      

      this.getproperties();
      this.getAltSymbolsParams();

    },
    watch: {
      categoryId: function(){

        this.getproperties();
      }

    },
    updated() {

    },
    mounted: function () {

    },
  methods: {
    
    getAltSymbolsParams() {

      let vue = this;

      this.$store.dispatch(this.$store.getters.sectionPrefix + "_getAltSymbolsParams")
      .then((result) => {
        console.log(result)
        vue.altSymbolsParams = result.data[0];
        
      })
      
    },
    getproperties(){

      let vue = this;

      this.properties = [];

      let obj = {
        categoryId: this.categoryId

      }

      this.$store.dispatch(this.$store.getters.sectionPrefix + "_getProperties", obj)
      .then(function(result) {
        
        console.log(result)

        if (result.status == "OK"){

          

          for (let i = 0, lei = result.data.length; i < lei; i++){
            
            if (result.data[i].type != "part number") {
              
              vue.properties.push(result.data[i]);
            }
          }



          vue.buildTable();
        }

      })

    },
    validateValues(obj) {
      console.log(obj)
      let vue = this;

      let arr = [obj];

      this.$store.dispatch(this.$store.getters.sectionPrefix + "_createNewPartValidation", arr)
        .then((result) => {

          console.log(result);

          if (result.status == "OK") {
            if (result.data.valid == false) {
              

              for (let i = 0, lei = result.data.violatedRules.length; i < lei; i++){

                vue.displayValidationRules(result.data.violatedRules[i])
              }
            } else {
              vue.resetValidationRules(obj);
            }
          }

          

        })


    },
    displayValidationRules(obj) {

      let id = "value__" + obj.propertyId;
      let elem = document.getElementById(id);
      elem.classList.add("warning");

      let idInvalidFeedback = id + "__invalid";
      let elemInvalidFeedback = document.getElementById(idInvalidFeedback);
      elemInvalidFeedback.setAttribute("style", "display: block");
      elemInvalidFeedback.innerHTML = obj.message;

    },
    resetValidationRules(obj) {

      let id = "value__" + obj.propertyId;
      let elem = document.getElementById(id);
      elem.classList.remove("warning");

      let idInvalidFeedback = id + "__invalid";
      let elemInvalidFeedback = document.getElementById(idInvalidFeedback);
      elemInvalidFeedback.setAttribute("style", "display: none");
      elemInvalidFeedback.innerHTML = "";
    },
        buildTable(){
          
          this.$store.dispatch("resetPropertyToSaving");

          for (let i = 0, lei = this.properties.length; i < lei; i++){

            if (this.properties[i].isRequiredOnRequest == true){
              let obj = {
                propertyId: this.properties[i].propertyId,
                value: "",
                type: this.properties[i].type,
                isRequiredOnRequest: this.properties[i].isRequiredOnRequest
              }

              this.$store.dispatch("addPropertyToSaving", obj);
            }


          }

          var tableplace = document.getElementById(this.id);
          if (tableplace == null){
            return
          }
          while (tableplace.firstChild) {
              tableplace.removeChild(tableplace.firstChild);
          }

          var table = document.createElement("table");
          table.setAttribute("id", "t_" + this.id);
          table.setAttribute("class", "table table-striped table-bordered");
          tableplace.appendChild(table)

          var tr = document.createElement("tr");

          var thead = document.createElement("thead");
          thead.appendChild(tr);

          table.appendChild(thead);

          let vue = this;


          let cols =  [
            { "data": "propertyId" },
            { "data": "priority" },
            { "data": "name" },

          ]

          let columns = [
            {
              name: "Id",
              alignInColumn: "left",

            },
            {
              name: "Priority",
              alignInColumn: "left",

            },
            {
              name: this.lang.table_header_Name,
              alignInColumn: "left",

            },
            {
              name: this.lang.table_header_Value,
              alignInColumn: "left",

            },



          ]




          var columnDefs = [];

          for (var i = 0, len = columns.length; i < len; i++){

            let classname = '_dt-body-'+ columns[i].alignInColumn;

            let  el = {
                targets: i,
                className: classname,
                render: function ( data, type, row, meta ) {
                  if (data == null) {
                    data = "";
                  }

                  data = $.fn.dataTable.render.text().display(data);
                  if (data.display != undefined) {
                    data.display = $.fn.dataTable.render.text().display(data.display);
                  }

                  if (meta.col == 1){
                    
                    
                    return data;
                  }
                  if (meta.col == 2){
                    let required = "<span class=\"required\">";
                    
                    
                    if (row.isRequiredOnRequest == true){
                      required += "<b-badge class=\"badge badge-blue\">Request</b-badge>";
                    }
                      
                    required += "</span>"
                    
                    return data + "   " + required;
                    
                  }
                  if (meta.col == 3){
                                          

                    if (row.type == PartPropertiesType.IMAGE){
                      //if (data.display == ""){
                        let src = "/static/" + vue.$store.getters.selectedTreeItemObject.category + "/img.png";
                      //}

                      let img = "<img src=\"" + src + "\" class=\"img-thumbnail img-fluid\"><br><br>";
                      img += "<div role=\"group\" class=\"input-group input-group-sm\">";
                      img += "<div class=\"custom-file b-form-file import-file b-custom-control-sm\">";
                      img += "<input data-type=\""+row.type+"\" id=\"file__"+row.propertyId +"__" + row.isRequiredOnRequest + "\" class=\"custom-file-input is-invalid\" type=\"file\">";
                      img += "<label class=\"custom-file-label\" data-browse=\"Browse\">";
                      img += "<span class=\"d-block form-file-text\">Choose a image</span>";
                      img += "</label>";
                      img += "</div>";
                      img += "</div>";
                      return img;
                    }else if (row.type == PartPropertiesType.TEXT){

                      let str = "";
                      
                      str += "<input data-type=\"" + row.type + "\" data-isRequiredOnRequest=\"" + row.isRequiredOnRequest + "\"  class=\"form-control new-part\" id=\"value__" + row.propertyId + "\" list=\"datalist__" + row.propertyId + "\" value=\"\"></input>";
                      str += "<datalist id=\"datalist__" + row.propertyId + "\" ></datalist>";
                      str += "<div class=\"invalid\" id=\"value__" + row.propertyId + "__invalid\"></div>";

                      return str;

                    } else if (row.type == PartPropertiesType.DESCRIPTION) {

                      let str = "";

                      str += "<input data-type=\"" + row.type + "\" data-isRequiredOnRequest=\"" + row.isRequiredOnRequest + "\"  class=\"form-control new-part\" id=\"value__" + row.propertyId + "\" list=\"datalist__" + row.propertyId + "\" value=\"\"></input>";
                      str += "<datalist id=\"datalist__" + row.propertyId + "\" ></datalist>";
                      str += "<div class=\"invalid\" id=\"value__" + row.propertyId + "__invalid\"></div>";

                      return str;
                    
                    }else if (row.type == PartPropertiesType.VALUE){

                      let str = "";
                      
                      str += "<input data-type=\"" + row.type + "\" data-isRequiredOnRequest=\"" + row.isRequiredOnRequest + "\"  class=\"form-control new-part\" id=\"value__" + row.propertyId + "\" list=\"datalist__" + row.propertyId + "\" value=\"\"></input>";
                      str += "<datalist id=\"datalist__" + row.propertyId + "\" ></datalist>";
                      str += "<div class=\"invalid\" id=\"value__" + row.propertyId + "__invalid\"></div>";

                      return str;  
                    }else if (row.type == PartPropertiesType.TYPE){
                      let str = "<select  data-isRequiredOnRequest=\"" + row.isRequiredOnRequest + "\"  class=\"form-control new-part type-select\" id=\"value__" + row.propertyId + "\">";
                          
                      const tab = ["Electric", "Mechanical", "Software"];
                      for (let j = 0, lej = tab.length; j < lej; j++){

                        let selected = "";
                        
                        str += "<option value=\""+tab[j]+"\" "+selected+">"+tab[j]+"</option>";
                      }
                      
                      str += "</select>";
                      str += "<div class=\"invalid\" id=\"value__" + row.propertyId + "__invalid\"></div>";

                      const obj = {
                        propertyId: row.propertyId,
                        value: "Electric",
                        type: "type"
                      }
                      
                      vue.$store.dispatch("addPropertyToSaving", obj);

                      return  str; 

                    }else if (row.type == PartPropertiesType.ROHS){

                      let str = "";
                      
                      str += "<input data-type=\"" + row.type + "\" data-isRequiredOnRequest=\"" + row.isRequiredOnRequest + "\"  class=\"form-control new-part\" id=\"value__" + row.propertyId + "\" list=\"datalist__" + row.propertyId + "\" value=\"\"></input>";
                      str += "<datalist id=\"datalist__" + row.propertyId + "\" ></datalist>";
                      str += "<div class=\"invalid\" id=\"value__" + row.propertyId + "__invalid\"></div>";
                      
                      return str;
                    // }else if (row.type == "date"){

                    //   let str = "";
                    //   str += "<div role=\"group\" class=\"input-group input-group-sm\">";
                    //   str += "<input data-type=\""+row.type+"\" data-isRequiredOnRequest=\"" + row.isRequiredOnRequest + "\"  class=\"form-control new-part\" type=\"date\" id=\"value__" + row.propertyId + "\" value=\"\">";
                    //   str += "</div>";
                    //   str += "<div class=\"invalid\" id=\"value__" + row.propertyId + "__invalid\"></div>";

                    //   return str;  
                    } else if (row.type == PartPropertiesType.PART || row.type == PartPropertiesType.SYMBOL){

                      let str = "<div role=\"group\" class=\"input-group\">";
                      str += "<input data-type=\""+row.type+"\" data-isRequiredOnRequest=\"" + row.isRequiredOnRequest + "\"  class=\"form-control form-control-sm new-part\"  type=\"text\" id=\"value__" + row.propertyId + "\" value=\"\"></input>";
                      str += "<div class=\"input-group-append\">";
                        str += "<button  class=\"btn btn btn-secondary btn-sm btn-"+vue.variant+" form-control-sm button-action-symbol\" id=\"symbolId__" + row.propertyId +"\" >"+vue.lang.button_Symbol+"</button>";

                      str += "</div></div>";
                      str += "<div class=\"invalid\" id=\"value__" + row.propertyId + "__invalid\"></div>";

                      return str;
                    } else if (row.type == PartPropertiesType.HDLSYMBOL) {

                      let str = "<div role=\"group\" class=\"input-group\">";
                      str += "<input data-type=\"" + row.type + "\" data-isRequiredOnRequest=\"" + row.isRequiredOnRequest + "\"  class=\"form-control form-control-sm new-part\"  type=\"text\" id=\"value__" + row.propertyId + "\" value=\"\"></input>";
                      str += "<div class=\"input-group-append\">";
                      str += "<button  class=\"btn btn btn-secondary btn-sm btn-" + vue.variant + " form-control-sm button-action-symbol\" id=\"hdlsymbolId__" + row.propertyId + "\" >" + vue.lang.button_Symbol + "</button>";

                      str += "</div></div>";
                      str += "<div class=\"invalid\" id=\"value__" + row.propertyId + "__invalid\"></div>";

                      return str;
                    } else if (row.type == PartPropertiesType.FOOTPRINT){
                      let str = "<div role=\"group\" class=\"input-group\">";
                      str += "<input data-type=\""+row.type+"\" data-isRequiredOnRequest=\"" + row.isRequiredOnRequest + "\"  class=\"form-control form-control-sm new-part\"  type=\"text\" id=\"value__" + row.propertyId + "\" value=\"\"></input>";
                      str += "<div class=\"input-group-append\">";
                        str += "<button  class=\"btn btn btn-secondary btn-sm btn-"+ vue.variant+" form-control-sm button-action-footprint\" id=\"footprintId__" + row.propertyId + "\" >"+vue.lang.button_Footprint+"</button>";
                        
                      str += "</div></div>";
                      str += "<div class=\"invalid\" id=\"value__" + row.propertyId + "__invalid\"></div>";

                      return str;
                    } else if (row.type == PartPropertiesType.LIBRARY) {
                      let str = "<div role=\"group\" class=\"input-group\">";
                      str += "<input disabled data-type=\"" + row.type + "\" data-isRequiredOnRequest=\"" + row.isRequiredOnRequest + "\"  class=\"form-control form-control-sm new-part\"  type=\"text\" id=\"value__" + row.propertyId + "\" value=\"\"></input>";
                      str += "<div class=\"input-group-append\">";
                      str += "<button  class=\"btn btn btn-secondary btn-sm btn-" + vue.variant + " form-control-sm button-action-library\" id=\"footprintId__" + row.propertyId + "\" >" + vue.lang.button_Library + "</button>";

                      str += "</div></div>";
                      str += "<div class=\"invalid\" id=\"value__" + row.propertyId + "__invalid\"></div>";

                      return str;
                    } else if (row.type == PartPropertiesType.ALTSYMBOLS) {

                      let str = "<div role=\"group\" class=\"input-group\">";
                      str += "<input data-type=\"" + row.type + "\" data-isRequiredOnRequest=\"" + row.isRequiredOnRequest + "\"  class=\"form-control form-control-sm new-part\"  type=\"text\" id=\"value__" + row.propertyId + "\" value=\"\"></input>";
                      str += "<div class=\"input-group-append\">";
                      str += "<button  class=\"btn btn btn-secondary btn-sm btn-" + vue.variant + " form-control-sm button-action-altsymbols\" id=\"altsymbolId__" + row.propertyId + "\" >" + vue.lang.button_AltSymbols + "</button>";

                      str += "</div></div>";
                      str += "<div class=\"invalid\" id=\"value__" + row.propertyId + "__invalid\"></div>";

                      return str;  
                    }else if (row.type == PartPropertiesType.LINK){
                      let str = "";
                      str += "<div role=\"group\" class=\"input-group input-group-sm\">";
                      str += "<input list=\"datalist__" + row.propertyId + "\" data-type=\""+row.type+"\" data-isRequiredOnRequest=\"" + row.isRequiredOnRequest + "\"  class=\"form-control new-part\" type=\"text\" id=\"value__" + row.propertyId + "\" value=\"https://\">";
                      str += "</div>";
                      str += "<datalist id=\"datalist__" + row.propertyId + "\" ></datalist>";
                      str += "<div class=\"invalid\" id=\"value__" + row.propertyId + "__invalid\"></div>";

                      return str;

                    }else if (row.type == PartPropertiesType.PARTNUMBER){
                      let pn = "";

                      let str = "";
                      
                      str += "<div role=\"group\" class=\"input-group input-group-pn input-group-sm\">";
                      str += "<input data-type=\""+row.type+"\"  data-isRequiredOnRequest=\"" + row.isRequiredOnRequest + "\" class=\"form-control new-part\" type=\"text\" id=\"value__" + row.propertyId + "\" value=\"" + pn + " \" disabled=disabled>";
                      str += "</div><small id=\"input-live-help\" class=\"form-text text-muted\">" + vue.lang.label_PartNumber + "</small>";
                      str += "<div class=\"invalid\" id=\"value__" + row.propertyId + "__invalid\"></div>";
                      
                      return str;

                    }else{
                      let str = "";
                      
                      str += "<input data-type=\"" + row.type + "\"  data-isRequiredOnRequest=\"" + row.isRequiredOnRequest + "\" class=\"form-control new-part\" id=\"value__" + row.propertyId + "\" list=\"datalist__" + row.propertyId + "\" value=\"\"></input>";
                      str += "<datalist id=\"datalist__" + row.propertyId + "\" ></datalist>";
                      str += "<div class=\"invalid\" id=\"value__" + row.propertyId + "__invalid\"></div>";

                      return str;
                    }

                  }

                  return data;
                }
              }

            columnDefs.push(el);


            var th = document.createElement("th");
            tr.appendChild(th);
            var br = document.createElement("br");
            th.appendChild(br);

            var tx = document.createTextNode(columns[i].name)
            th.appendChild(tx);


          }


          var json = {};
          json.paging = false;
          json.info = false;
          json.dom = 'f<t>';
          json.data= this.properties;
          json.myColumnFormats = columns;
          json.select = false;
          json.columns = cols;
          json.columnDefs = columnDefs;
          json.order = [1, "asc"];


          if ($.fn.dataTable.isDataTable("#t_"+this.id)) {
              this.mainTable.destroy();
              
          }



          this.mainTable = $('#t_'+this.id).DataTable(json);

          
          

          //hide first column in table
          this.mainTable.column( 0 ).visible( false );
          this.mainTable.column( 1 ).visible( false );

          //search input change view
          var searchplace = document.getElementById("t_" + this.id + "_filter").firstChild

          while (searchplace.firstChild) {

            if (searchplace.firstChild.textContent == "Search:"){
                searchplace.removeChild(searchplace.firstChild);
                break;
            }

          }

          searchplace.firstChild.setAttribute("placeholder", this.lang.placeholder_Search);
          searchplace.firstChild.setAttribute("class", "form-control form-control-sm")

          

          let editParts = document.getElementsByClassName('new-part');

          for (var i = 0; i < editParts.length; i++) {
            editParts[i].addEventListener('input', function (e){

              let temp = this.id.split("__");
              let propertyId = temp[1];
              let type = $(this).attr("data-type");
              let isRequiredOnRequest = $(this).attr("data-isRequiredOnRequest");

              const obj = {
                propertyId: propertyId,
                value: this.value,
                type: type,
                isRequiredOnRequest: isRequiredOnRequest
              }
              const validObj = {
                propertyId: propertyId,
                value: this.value,
              }
              vue.validateValues(validObj);

              vue.$store.dispatch("addPropertyToSaving", obj);
            })
          }

          for (var i = 0; i < editParts.length; i++) {
            editParts[i].addEventListener('focus', function (e) {

              let temp = this.id.split("__");

              let obj = {
                propertyId: temp[1],
                categoryId: vue.$store.getters.selectedTreeItemObject.categoryId
              }


              vue.$store.dispatch(vue.$store.getters.sectionPrefix + "_getAutocompleteValues", obj)
                .then((result) => {
                  
                  let str = "";
                  for (let i = 0, lei = result.data.length; i < lei; i++) {
                    str += "<option>" + result.data[i] + "</option>";
                  }

                  let place = document.getElementById("datalist__" + temp[1])
                  if (place == null) {
                    return
                  }
                  
                  place.innerHTML = str;
            

                })
            })
          }

          let symbols_buttons = document.getElementsByClassName('button-action-symbol');

          for (let i = 0, lei = symbols_buttons.length; i < lei; i++) {
            symbols_buttons[i].addEventListener('click', function (e) {

              vue.$store.dispatch(vue.$store.getters.sectionPrefix + "_deleteAllSelectedSymbols");

              let id = this.id;
              let temp = id.split("__");
              let f = document.getElementById("value__" + temp[1])
              let selectedSymbols = f.value;
              let propertyId = temp[1];
              
              let isRequiredOnRequest = $(this).attr("data-isRequiredOnRequest");
              
              let type = f.dataset.type;

              

              let validateValues = vue.validateValues;

              let funcYes = function(vue){

                let type = type;



                let str = "";
                for (let i = 0, lei = vue.$store.getters.selectedSymbols.length; i < lei; i++){
                  
                  str += vue.$store.getters.selectedSymbols[i].name;
                  if (i < lei - 1){
                    str += ",";
                  }

                }
                
                
                f.value = str;

                const obj = {
                  propertyId: propertyId,
                  value: str,
                  type: type,
                  isRequiredOnRequest: isRequiredOnRequest
                }
                const validObj = {
                  propertyId: propertyId,
                  value: str,
                }
                validateValues(validObj);

                vue.$store.dispatch("addPropertyToSaving", obj);
                
              }
              
              if (type == PartPropertiesType.HDLSYMBOL) {
                vue.lang.modal_Symbols.modal_Title = vue.lang.modal_Symbols.modal_TitleHDL;
              } if (type == PartPropertiesType.PART || type == PartPropertiesType.SYMBOL) {
                vue.lang.modal_Symbols.modal_Title = vue.lang.modal_Symbols.modal_TitleSymbols
              }
              
              const obj = {
                //title: title,
                text: "",
                type: "symbols",
                selected: selectedSymbols,
                buttons: 2,
                size: "lg",
                lang: vue.lang.modal_Symbols,
                data: {
                  type: type,
                },
                funcNo: "",
                funcYes: funcYes,
                
              };
              
              vue.$store.dispatch("showModalComponent", obj);
            })
          }

          let footprints_buttons = document.getElementsByClassName('button-action-footprint');

          for (let i = 0, lei = footprints_buttons.length; i < lei; i++) {
            footprints_buttons[i].addEventListener('click', function (e){

              vue.$store.dispatch(vue.$store.getters.sectionPrefix + "_deleteSelectedFootprint");

              let id = this.id;
              let temp = id.split("__");
              let f = document.getElementById("value__" + temp[1])
              let selectedFootprint = f.value;
              let propertyId = temp[1];

              let isRequiredOnRequest = $(this).attr("data-isRequiredOnRequest");

              let type = f.dataset.type;

              let validateValues = vue.validateValues;

              let funcYes = function(vue){

              

              
                f.value = vue.$store.getters.selectedFootprints[0].name;

                const obj = {
                  propertyId: propertyId,
                  value: vue.$store.getters.selectedFootprints[0].name,
                  type: PartPropertiesType.FOOTPRINT,
                  isRequiredOnRequest: isRequiredOnRequest
                }
                const validObj = {
                  propertyId: propertyId,
                  value: vue.$store.getters.selectedFootprints[0].name,
                }
                validateValues(validObj);

                vue.$store.dispatch("addPropertyToSaving", obj);
                
              }

              const obj = {
                title: "Footprints",
                text: "",
                type: "footprints",
                selected: selectedFootprint,
                buttons: 2,
                size: "lg",
                lang: vue.lang.modal_Footprints,
                funcNo: "",
                funcYes: funcYes,
                
              };
              vue.$store.dispatch("showModalComponent", obj);
            })
          }

          let library_buttons = document.getElementsByClassName('button-action-library');

          for (let i = 0, lei = library_buttons.length; i < lei; i++) {
            library_buttons[i].addEventListener('click', function (e) {

              vue.$store.dispatch(vue.$store.getters.sectionPrefix + "_deleteSelectedFootprint");

              let id = this.id;
              let temp = id.split("__");
              
              let propertyId = temp[1];
              let type = $(this).attr("data-type");
              let isRequiredOnRequest = $(this).attr("data-isRequiredOnRequest");

              let f = document.getElementById("value__" + temp[1])
              let selectedFootprint = f.value;
              let validateValues = vue.validateValues;

              let funcYes = function (vue) {




                f.value = vue.$store.getters.selectedFootprints[0].name;

                const obj = {
                  propertyId: propertyId,
                  value: vue.$store.getters.selectedFootprints[0].name,
                  type: "library",
                  isRequiredOnRequest: isRequiredOnRequest
                }
                const validObj = {
                  propertyId: propertyId,
                  value: vue.$store.getters.selectedFootprints[0].name,
                }
                validateValues(validObj);
                vue.$store.dispatch("addPropertyToSaving", obj);

              }

              const obj = {
                title: "Libraries",
                text: "",
                type: "libraries",
                selected: selectedFootprint,
                data: {
                  propertyId: propertyId
                },
                buttons: 2,
                size: "lg",
                lang: vue.lang.modal_Libraries,
                funcNo: "",
                funcYes: funcYes,

              };
              console.log(obj)
              vue.$store.dispatch("showModalComponent", obj);
            })
          }

          let altsymbols_buttons = document.getElementsByClassName('button-action-altsymbols');

          for (let i = 0, lei = altsymbols_buttons.length; i < lei; i++) {
            altsymbols_buttons[i].addEventListener('click', function (e) {

              vue.$store.dispatch(vue.$store.getters.sectionPrefix + "_deleteAllSelectedAltSymbols");

              let id = this.id;
              let temp = id.split("__");

              let propertyId = temp[1];
              let type = $(this).attr("data-type");
              let isRequiredOnRequest = $(this).attr("data-isRequiredOnRequest");

              let f = document.getElementById("value__" + temp[1])
              let selectedFootprint = f.value;



              let validateValues = vue.validateValues;

              let altSymbolsParams = vue.altSymbolsParams;

              let funcYes = function (vue) {

                let type = type;

                let str = "(";
                for (let i = 0, lei = vue.$store.getters.selectedAltSymbols.length; i < lei; i++) {
                                      
                  str += altSymbolsParams[vue.$store.getters.selectedAltSymbols[i].side] + ":" + vue.$store.getters.selectedAltSymbols[i].name;
                  if (i < lei - 1) {
                    str += ";";
                  }

                }
                str += ")";
            
                f.value = str;

                const obj = {
                  propertyId: propertyId,
                  value: str,
                  type: "alt symbols",
                  isRequiredOnRequest: isRequiredOnRequest
                }
                const validObj = {
                  propertyId: propertyId,
                  value: str,
                }
                validateValues(validObj);

                vue.$store.dispatch("addPropertyToSaving", obj);


              }

              const obj = {
                title: "ALT_SYMBOLS",
                text: "",
                type: "altsymbols",
                selected: selectedFootprint,
                data: {
                  propertyId: propertyId
                },
                buttons: 2,
                size: "lg",
                lang: vue.lang.modal_AltSymbols,
                funcNo: "",
                funcYes: funcYes,

              };
              console.log(obj)
              vue.$store.dispatch("showModalComponent", obj);
            })
          }


        },

      }

  }
</script>
<style lang="scss">

  @import "./../../scss/_custom.scss";

  .NewPartFormComponent{
    table{

      padding: 0px !important;

    }
    table th {
      padding: 0rem !important;

      padding-left: 0.2rem !important;
      padding-right: 0.2rem !important;

    }
    table.dataTable thead th {
        position: relative;
        background-image: none !important;
    }
    table td {
      padding: 0.2rem !important;

    }

    .dataTables_filter{
      font-size: 10px;
    }
    .searcher{
      float: left;
    }
    .dataTables_filter .form-control-sm, .input-group-sm > .form-control{

      font-size: 0.7rem;
      line-height: 1;
      width: 200px;
    }
    ._dt-body-left{
      text-align: left;
    }
    ._dt-body-right{
      text-align: right;
    }
    ._dt-body-center{
      text-align: center;
    }
    .red{
      color: $redfont;
    }
    .red-img{
      background-color: $red;
      border: 0px;
    }
    .green{
      color: $green;
    }
    .green-img{
      background-color: $green;
      border: 0px;
    }
    .svg-image{
      background-color: white;
      margin: 10px;
      border: 1px solid #cccccc;
    }

    .btn{
      height: 26.8px;
    }
    td{
      word-break: break-all;
    }
    input-group{
      min-width: 200px;

    }
    input-group-pn{
      min-width: 150px;

    }
    input-group-prepend{
      height: 26.8px !important;
      widows: 24px;
    }
    .img-thumbnail{
      width: 100px;
    }
    .form-control{
      height: 26.8px;
    }
    .required{
      float: right;
      margin: 2px;
    }
    .type-select{
      padding-top: 5px;
      font-size: 0.7rem;
      padding-left: 5px;
    }
    input::-webkit-calendar-picker-indicator {
      opacity: 0;
    }
    .warning{
      border-color: $redfont !important;
    }
    .invalid{
      color: $redfont;
      font-size: 0.7rem;
      display: none;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/shared/NewPartFormComponent.vue